// extracted by mini-css-extract-plugin
module.exports = {"cardHeader":"Customer_cardHeader__3Jyn1","card":"Customer_card__3zyB_","tabContent":"Customer_tabContent__389h4","navTabs":"Customer_navTabs__3tJIf"};